/**
 *
 * File
 *
 */

import React from "react";
import { toast } from "sonner";
import {
  Label,
  Input,
  ColorOpenerWrapper,
  StyledSecondButton,
  ColorContainer,
  SecondButtonText,
  OrText,
  Wrapper,
  LabelButton,
  ButtonGroup,
  UnstyledInput,
  FileWrapper,
  SelectIcon,
} from "./styledComponents";

import InputValidator from "components/InputValidator";
import Icon from "components/Icon";
import { colors } from "globalStyles";

// Monotonic fallback for id generation — class components cannot useId(),
// same pattern as Select.js. Links each visible <Label> to its input.
let fileIdSeq = 0;

// TODO: Refactor to ColorPickerButton and decouple from File component
class SecondButton extends React.PureComponent {
  render() {
    const { hasFirstButton, buttonText, onClick } = this.props;
    return (
      <Wrapper innerRef={(ref) => (this.siblingRef = ref)}>
        {hasFirstButton && <OrText>or Pick a Color:</OrText>}
        <StyledSecondButton
          onClick={() => onClick(this.siblingRef)}
          type="button"
        >
          <ColorContainer backgroundColor={buttonText} />
          <SecondButtonText>{buttonText}</SecondButtonText>
        </StyledSecondButton>
      </Wrapper>
    );
  }
}

const DropDownArrow = () => <Icon size="10" name="drop-down" />;

export class ColorPickerButton extends React.PureComponent {
  fieldId = this.props.id || `color-${++fileIdSeq}`;

  componentDidMount() {
    const { value, buttonText, onChange } = this.props;

    if (!value && buttonText) {
      onChange(buttonText);
    }
  }

  render() {
    const {
      buttonText,
      onClick,
      label,
      disabled,
      colorPreviewOnLeft,
      placeholder,
      enableRemoveIcon,
      onChange,
      field,
      ...input
    } = this.props;
    const openPicker = () =>
      !disabled &&
      onClick({
        hex: buttonText,
        siblingRef: this.siblingRef,
        onChange,
        label,
      });
    return (
      <Wrapper ref={(ref) => (this.siblingRef = ref)}>
        <Input
          className={`${colorPreviewOnLeft ? "has-icon" : ""}`}
          {...field}
          id={this.fieldId}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) =>
            e.target.value === ""
              ? onChange("")
              : onChange(
                  (e.target.value[0] === "#" ? "" : "#") +
                    e.target.value.replace(/[^#0-9A-Za-z]/g, "")
                )
          }
        />
        <Label htmlFor={this.fieldId}>{label}</Label>
        <ColorOpenerWrapper
          type="button"
          className={colorPreviewOnLeft ? "left" : undefined}
          aria-label="Open color picker"
          onClick={openPicker}
        >
          <ColorContainer backgroundColor={buttonText || colors.MENU} />
        </ColorOpenerWrapper>
        {enableRemoveIcon && buttonText && (
          <SelectIcon
            className="right pt-1.5"
            role="button"
            tabIndex={0}
            aria-label="Clear selection"
            onClick={() => onChange("")}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange("");
              }
            }}
          >
            <Icon name="x" size="10" />
          </SelectIcon>
        )}
      </Wrapper>
    );
  }
}

class File extends React.PureComponent {
  fieldId = this.props.id || `file-${++fileIdSeq}`;

  state = {
    trickUploadSameFile: false,
  };

  componentDidUpdate(prevProps) {
    const {
      input: { value },
    } = this.props;

    // Hack for upload same file
    if (prevProps.input.value !== value) {
      this.setState({ trickUploadSameFile: true }, () => {
        this.setState({ trickUploadSameFile: false });
      });
    }
  }

  customOnChange = (value) => {
    const { validateFnc, validateMsg, input } = this.props;
    if (validateFnc) {
      const files = value.target.files;
      validateFnc(value)
        .then(() => input.onChange(files))
        .catch(() => {
          validateMsg && toast.warning(validateMsg);
          this.setState({ trickUploadSameFile: true }, () => {
            this.setState({ trickUploadSameFile: false });
          });
        });
    } else {
      input.onChange(value);
    }
  };

  render() {
    const {
      field: { value, ...inputProps },
      label,
      accept,
      className,
      children,
      inputClassName,
      labelClassName,
      iconOffset,
      validIconName,
      errorIconName,
      emptyIconName,
      buttonText,
      secondButtonProps,
      height,
      labelMarginLeft,
      showButton,
      errMsg,
    } = this.props;
    const hasError = errMsg ? true : false,
      isValid = value && errMsg ? true : false;
    const labelMarginTop = -1 * (height + 7);

    return (
      <Wrapper className={className}>
        <FileWrapper
          height={height}
          hasError={hasError}
          className={inputClassName}
        >
          {children}
          {showButton && (
            <ButtonGroup hasButtonText={!!buttonText}>
              {buttonText && (
                <LabelButton>
                  {!this.state.trickUploadSameFile && (
                    <UnstyledInput
                      {...inputProps}
                      id={this.fieldId}
                      onChange={this.customOnChange}
                      type="file"
                      accept={accept}
                      hidden
                    />
                  )}
                  {buttonText}
                </LabelButton>
              )}
              {secondButtonProps && (
                <SecondButton
                  hasFirstButton={!!buttonText}
                  onChange={this.customOnChange}
                  {...secondButtonProps}
                />
              )}
            </ButtonGroup>
          )}
        </FileWrapper>
        <Label
          htmlFor={this.fieldId}
          marginTop={labelMarginTop}
          marginLeft={labelMarginLeft}
          className={labelClassName}
        >
          {label}
        </Label>
        <InputValidator
          isValid={isValid}
          hasError={hasError}
          offset={iconOffset}
          validIconName={validIconName}
          errorIconName={errorIconName}
          emptyIconName={emptyIconName}
        />

        <Icon className="drop-down-arrow" size="6" name="drop-down-arrow" />
      </Wrapper>
    );
  }
}

export default File;
